import { AuthSessionContext } from 'api/AuthSession'
import {
    Button,
    Heading,
    List,
    ListItem,
    ListItemIcon,
    Menu,
    MenuButton,
    MenuItem,
    SplitButton,
} from 'monday-ui-react-core'
import LogOut from 'monday-ui-react-core/dist/icons/LogOut'
import React, { useContext, useEffect, useState } from 'react'
import { Col, Container, Modal, Navbar, Row } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import { StatementContext } from 'utils/context/StatementsContext'
import whiteLogo from './../../assest/images/AppLogo.png'

const LOG_OUT_PATHS = ['/signin', '/forgot-password', '/create-account', '/setup-account']
const HIDE_LOGO_PATHS = ['/setup-account']

const Header = () => {
    const [show, setShow] = useState(false)
    const [whiteBg, setWhiteBg] = useState(false)
    const [showMenu, setShowMenu] = useState(false)
    const [organizationName, setOrganizationName] = useState('')
    const { logout, getSession, userName } = useContext(AuthSessionContext)
    const { cleanStore } = useContext(StatementContext)

    const navigate = useNavigate()
    const location = useLocation()

    const showLogo = !HIDE_LOGO_PATHS.includes(location.pathname) ?? true

    const handleClose = () => setShow(false)

    const handleShow = () => setShow(true)

    const onClickLogout = () => {
        setShow(false)
        cleanStore()
        logout()
    }

    const onLogoClick = () => {
        if (!showLogo)
            return;
        
        navigate({ pathname: '/dashboard' })
    }

    const handleRedirectionUserAccount = () => {
        navigate({ pathname: '/account/user' })
    }

    const handleRedirectionOrganization = () => {
        navigate({ pathname: '/account/organization' })
    }

    useEffect(() => {
        if (LOG_OUT_PATHS.includes(location.pathname)) {
            setShowMenu(false)
        } else {
            setShowMenu(true)
            getSession()
        }
    }, [location])

    useEffect(() => {
        function setOrgName() {
            setOrganizationName(localStorage.getItem('OrganizationName'))
        }

        window.addEventListener('OrganizationUpdated', setOrgName)

        return () => window.removeEventListener('OrganizationUpdated', setOrgName)
    }, [])

    const navbarMenu = () => (
        <Container>
            <Row className="header-menu justify-content-end" xs={12} md={12} lg={12}>
                <MenuButton
                    dialogPosition='bottom-end'
                    className='menu-button'
                    closeDialogOnContentClick
                    component={props => (
                        <Container className='menu-label'>
                            <Row className="justify-content-end org-name">
                                <label>{userName}</label>
                            </Row><br/>
                            <Row className="justify-content-end org-name">
                                <label>{organizationName ?? ''}</label>
                            </Row>
                        </Container>
                    )}
                    
                >
                    <Menu id="menu" size={Menu.sizes.SMALL}>
                        <MenuItem
                            title='User Account'
                            onClick={handleRedirectionUserAccount}
                        />
                        <MenuItem
                            title='Organization'
                            onClick={handleRedirectionOrganization}
                        />
                        <MenuItem 
                            title='Sign out'
                            onClick={handleShow}
                            icon={LogOut}
                        />
                    </Menu>
                </MenuButton>
            </Row>
        </Container>
    )

    return (
        <>
            <Navbar className="navBar navbar-white">
                <Container>
                    <Row className="d-flex justify-content-between w-100">
                        <Col lg='auto' md='auto' className='border-option'>
                            <Navbar.Brand
                                onClick={onLogoClick}
                                href="#"
                                className="w-75"
                            >
                                <img
                                    src={whiteLogo}
                                    width="220px"
                                    className="cc-logo ml-4 d-inline-block align-top"
                                    alt="EnergilityDX Logo"
                                />
                            </Navbar.Brand>
                        </Col>
                        <Col></Col>
                        <Col lg='auto' md='auto'  className='border-option'>
                            <Navbar.Collapse className="justify-content-end text-right">
                                {showMenu && navbarMenu()}
                            </Navbar.Collapse>
                        </Col>
                    </Row>
                </Container>
            </Navbar>
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton />
                <Modal.Body>
                    <Heading value="Sign out?" />
                    <p>You are about to sign out of EnergilityDX.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button kind={Button.kinds.TERTIARY} onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button onClick={onClickLogout}>Sign out</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default Header
